import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "search-form" }
const _hoisted_2 = {
  key: 0,
  class: "analyzing",
  "data-test": "photo-upload-loader"
}
const _hoisted_3 = { class: "analyzing__info" }
const _hoisted_4 = { class: "analyzing__percent" }
const _hoisted_5 = { class: "analyzing__text" }
const _hoisted_6 = { class: "search-form__text" }
const _hoisted_7 = { class: "search-form__btn-text" }
const _hoisted_8 = { class: "search-form__btn search-form__btn--mobile btn btn--prim" }
const _hoisted_9 = { class: "search-form__example" }
const _hoisted_10 = { class: "search-form__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AProgress = _resolveComponent("AProgress")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isFetch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AProgress, {
            type: "circle",
            percent: _ctx.loadedPercent,
            "stroke-color": "#9252FA",
            width: 180,
            "show-info": false
          }, null, 8, ["percent"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.loadedPercent) + "%", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('modal_photo_upload_analyzing')) + "...", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_form, {
      model: _ctx.formState,
      class: "search-form__form",
      "data-test": "search-section-form",
      onSubmit: _withModifiers(_ctx.submitForm, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          value: _ctx.formState.search,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.search) = $event)),
          class: "search-form__input",
          placeholder: _ctx.t('form_placeholder_search_plant'),
          "data-test": "search-section-plant-input"
        }, {
          prefix: _withCtx(() => [
            _createVNode(_component_BaseIcon, { name: "search" })
          ]),
          _: 1
        }, 8, ["value", "placeholder"]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('text_or')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "search-form__btn search-form__btn--desktop btn btn--prim",
          "data-test": "search-section-upload-btn",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadPhoto && _ctx.uploadPhoto(...args)), ["prevent"]))
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t('form_button_upload')), 1),
          _createVNode(_component_BaseIcon, { name: "camera" })
        ]),
        _createElementVNode("label", _hoisted_8, [
          _createVNode(_component_BaseIcon, { name: "camera" }),
          _createElementVNode("input", {
            type: "file",
            hidden: "",
            accept: "image/*",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendFile && _ctx.sendFile(...args)))
          }, null, 32)
        ])
      ]),
      _: 1
    }, 8, ["model", "onSubmit"]),
    _createElementVNode("p", _hoisted_9, [
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('component_search_example')), 1),
      _createTextVNode(": " + _toDisplayString(_ctx.t('component_search_snake_plant')), 1)
    ])
  ]))
}